import { Box, Button, Card, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import styled from "styled-components";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  box-shadow: 0 2px 8px 0 rgba(0, 75, 123, 0.2);
  height: 14.75rem;
  border: 1px solid #fff;

  &.valuation-in-progress:hover {
    border: 1px solid #5bc0be;
  }

  &:hover {
    border: 1px solid ${cuideoTheme.palette.primary.main};
    cursor: pointer;
  }
`;

export const StyledServiceInfo = styled(Box)`
  padding: 0.5rem;
  width: 40%;
  border-right: 1px solid ${cuideoTheme.palette.divider};
  position: relative;
`;

export const StyledFirstRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 1.5rem;
  margin-bottom: 0.25rem;
`;

export const StyledCreated = styled(Typography)`
  font-size: 0.6875rem;
  line-height: 1;
  margin: 0;
  padding: 0;
  color: ${cuideoTheme.palette.primary.main};
  opacity: 0.5;
`;

export const StyledSecondRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const StyledServiceTitleDetails = styled(Box)``;

export const StyledServiceTitle = styled(Typography)`
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.15;
  color: #002740;
`;

export const StyledServiceDetails = styled(Box)``;

export const StyledServiceStatus = styled(Typography)`
  color: ${cuideoTheme.palette.primary.light};
  font-size: 0.75rem;
  text-align: right;
  line-height: 1.25;
`;

export const StyledThirdRow = styled(Box)``;

export const StyledBottomInfoLine = styled.div`
  position: absolute;
  bottom: 0.125rem;
  left: 0.375rem;
  display: flex;
  flex-direction: row;
  column-gap: 0.5rem;
`;

export const StyledItem = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 0.75rem 0;
`;

export const StyledIcon = styled.img`
  display: block;
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
  margin-top: 0.0625rem;
`;

export const StyledItemMoneyDetail = styled(Typography)`
  margin-top: 0;
  font-size: 1rem;
  line-height: 1.25;
  color: ${cuideoTheme.palette.primary.main};
`;

export const StyledServiceRight = styled(Box)`
  width: 60%;
  display: flex;
  flex-direction: column;
`;

export const StyledServiceRightTop = styled(Box)`
  padding: 0.5rem 0.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledServiceRightTopLeft = styled(Box)``;

export const StyledServiceRightTopRight = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const StyledTriItem = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.5rem;

  &:first-child {
    border-right: 1px solid ${cuideoTheme.palette.divider};
  }
`;

export const StyledTriIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  margin-right: 0.5rem;
`;

export const StyledTriDataWrapper = styled(Box)``;

export const StyledTriLabel = styled(Typography)`
  color: ${cuideoTheme.palette.primary.main};
  opacity: 0.5;
  font-size: 0.75rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.15;
`;

export const StyledTriData = styled(Typography)`
  color: ${cuideoTheme.palette.primary.main};
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  line-height: 1.15;
`;

export const StyledServiceName = styled(Typography)`
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-size: 0.9375rem;
  text-align: right;
  line-height: 1.25;
`;

export const StyledItemDetail = styled(Typography)`
  margin-top: 0;
  font-size: 0.75rem;
  line-height: 1.25;
  color: ${cuideoTheme.palette.primary.main};
`;

export const StyledServiceRightBottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;

export const StyledServiceRightBottomLeft = styled.div`
  padding: 0.25rem 0.75rem;
  flex-grow: 1;
`;

export const StyledServiceRightBottomRight = styled.div`
  padding: 0.25rem 0.75rem;
  min-width: 8rem;
  width: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .CMuiServiceCardButton {
    margin-bottom: 0.375rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledGeneralReportWrapper = styled(Box)`
  background-color: rgba(0, 72, 120, 0.05);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  box-sizing: border-box;
  height: 11rem;
`;

export const StyledGeneralReportTitle = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.55;
  color: ${cuideoTheme.palette.primary.main};
  border-bottom: 1px solid rgba(0, 72, 120, 0.1);
`;

export const StyledGeneralReport = styled(Typography)`
  font-size: 0.75rem;
  line-height: 1.25;
  color: ${cuideoTheme.palette.primary.main};

  overflow-y: scroll;
  height: 9rem;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 0.25rem;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 72, 120, 0.25);
    width: 0.5rem;
    border-radius: 0.25rem;
  }
`;

export const StyledEmptyGeneralReport = styled(Typography)`
  font-size: 0.75rem;
  font-style: italic;
  text-align: center;
  padding: 1rem 0;
  line-height: 1.25;
  color: ${cuideoTheme.palette.primary.main};
`;

export const StyledClickablePhoneNumber = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
  padding: 0 0.25rem;
  border-radius: ${cuideoTheme.shape.borderRadius}px;

  &:hover {
    background-color: rgba(0, 72, 120, 0.25);
  }
`;

export const StyledCardButton = styled(Button)`
  line-height: 1.25;
  font-size: 1rem;
`;

export const StyledValutaionInProgressAlert = styled(Alert)`
  margin-bottom: 0.25rem;
  padding: 0.125rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25;
`;
